import React, { useState, useEffect, useCallback } from 'react';
import socketService from '../services/socketService';
import Layout from '../components/Layout';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

const UserDeviceManager = () => {
    const navigate = useNavigate();
    
    // URL Params
    const queryParams = new URLSearchParams(window.location.search);
    const usernameFromUrl = queryParams.get('username');

    // --- States ---
    const [users, setUsers] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState('');
    const [selectedUserInfo, setSelectedUserInfo] = useState(null);
    const [devices, setDevices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);

    // Modal States
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingDevice, setEditingDevice] = useState(null);
    // --- SMS Commands Documentation Modal State ---
const [showSmsDocModal, setShowSmsDocModal] = useState(false);

    // --- Remote Config Modal States ---
    const [showConfigModal, setShowConfigModal] = useState(false);
    const [activeDeviceForConfig, setActiveDeviceForConfig] = useState(null);
    
    // --- App Settings Modal States ---
    const [showAppSettingsModal, setShowAppSettingsModal] = useState(false);
    const [activeDeviceForAppSettings, setActiveDeviceForAppSettings] = useState(null);

    // --- OTP Setting Modal States ---
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [otpDevice, setOtpDevice] = useState(null);
    const [otpForm, setOtpForm] = useState({
        username: '',
        blockusername: [],
        simNumber: '',
        status: 'active'
    });
    const [tempBlockUser, setTempBlockUser] = useState('');

    

    // --- USSD Manager Modal States ---
    const [showUSSDModal, setShowUSSDModal] = useState(false);
    const [activeDeviceForUSSD, setActiveDeviceForUSSD] = useState(null);
    const [ussdSimTab, setUssdSimTab] = useState('sim1'); 

    // 🔥 UPDATED: Added 'status' to state
    const [newUSSDForm, setNewUSSDForm] = useState({ typeName: '', steps: '', status: 'show' });
    const [editingUSSDIndex, setEditingUSSDIndex] = useState(null);

    // 🔥 NEW: Transaction History States
    const [transactionList, setTransactionList] = useState([]);
    const [showTrxModal, setShowTrxModal] = useState(false);
    const [loadingTrx, setLoadingTrx] = useState(false);

    // --- Mode Lock Modal States ---
    const [showModeLockModal, setShowModeLockModal] = useState(false);
    const [modeLockDevice, setModeLockDevice] = useState(null);
    const [modeLockForm, setModeLockForm] = useState({ issamiauto: false, isstanderpaid: false, isadvancepaid: false });

        const handleDeviceAction = (device, actionType) => {
        if (!window.confirm(`আপনি কি নিশ্চিত যে আপনি ${actionType} কমান্ড পাঠাতে চান?`)) return;

        // সকেটের মাধ্যমে ব্যাকএন্ডে ডেটা পাঠানো হচ্ছে
        const socket = socketService.getSocket();
        socket.emit('trigger_device_action', {
            deviceId: device._id || device.id,
            actionType: actionType
        });
        
        alert("কমান্ড পাঠানো হয়েছে!"); 
    };

        const handleAddTemplateDevice = () => {
        // প্রথমে চেক করে নিচ্ছি কোনো ইউজার সিলেক্ট করা আছে কি না
        if (!selectedUserId) {
            alert("দয়া করে আগে একজন ইউজার সিলেক্ট করুন!");
            return;
        }

        if (!window.confirm("আপনি কি এই ইউজারের জন্য অটো-কনফিগার করা নতুন ডিভাইস অ্যাড করতে চান?")) return;

        const socket = socketService.getSocket();
        
        // ব্যাকএন্ডে শুধু ইউজারের আইডি পাঠিয়ে দিচ্ছি
        socket.emit('userDeviceManager-addTemplateDevice', {
            userId: selectedUserId 
        });

        // ডেটা সেভ হওয়ার পর পেজ রিলোড
        setTimeout(() => {
            window.location.reload();
        }, 500); 
    };

    // Forms
    const [newAppSettingForm, setNewAppSettingForm] = useState({ 
        appName: '', 
        packageName: '', 
        isNagad: false,
        isBkash: false
    });

    const [newConfigForm, setNewConfigForm] = useState({
        appName: '', packageName: '', eventName: '', time: 5
    });

    const [eventModal, setEventModal] = useState({
        show: false,
        type: 'add',
        appIdx: null,
        eventIdx: null,
        data: { eventName: '', time: 5 }
    });

    // Add Form
    const initialAddForm = {
        deviceName: '', 
        sim1: '', sim1_balance: '',
        sim2: '', sim2_balance: ''
    };
    const [addForm, setAddForm] = useState(initialAddForm);

    // Permissions Logic
    const isMainAdmin = localStorage.getItem('isMaster') === 'true';
    let allowedUsers = [];
    try {
        allowedUsers = JSON.parse(localStorage.getItem('allowedUsers') || '[]');
    } catch (e) {
        allowedUsers = [];
    }

    const displayableUsers = isMainAdmin 
        ? users 
        : users.filter(u => allowedUsers.includes(u.id) || allowedUsers.includes(u._id));


    // --- Data Fetching Logic ---
    const fetchUserAndDevices = useCallback((userId) => {
        if (!userId) {
            setSelectedUserInfo(null);
            setDevices([]);
            return;
        }
        setLoading(true);
        setError(null);
        socketService.emit('userDeviceManager-fetchUserAndDevices', { userId });
    }, []);

    useEffect(() => {
        const socket = socketService.getSocket();
        if (!socket || !socket.connected) {
            socketService.connect();
        }

        socketService.emit('fetchUsersList');

        socketService.on('usersList', (data) => setUsers(data || []));

        socketService.on('userDeviceManager-userData', (data) => {
            setLoading(false);
            if (data.error) {
                setError(data.error);
                setSelectedUserInfo(null);
                setDevices([]);
            } else {
                setSelectedUserInfo(data.user);
                setDevices(data.devices || []);
                
                if (activeDeviceForConfig) {
                    const updated = data.devices.find(d => d._id === activeDeviceForConfig._id);
                    if (updated) setActiveDeviceForConfig(updated);
                }
                if (activeDeviceForAppSettings) {
                    const updated = data.devices.find(d => d._id === activeDeviceForAppSettings._id);
                    if (updated) setActiveDeviceForAppSettings(updated);
                }
                if (activeDeviceForUSSD) {
                    const updated = data.devices.find(d => d._id === activeDeviceForUSSD._id);
                    if (updated) setActiveDeviceForUSSD(updated);
                }
            }
        });

        const handleResponse = (data) => {
            setLoading(false);
            if (data?.success) {
                setSuccessMessage(data.message);
                if (selectedUserId) fetchUserAndDevices(selectedUserId); 
                setShowEditModal(false);
                setEventModal({ show: false, type: 'add', appIdx: null, eventIdx: null, data: { eventName: '', time: 5 } });
                
                setEditingUSSDIndex(null);
                setNewUSSDForm({ typeName: '', steps: '', status: 'show' });

                setTimeout(() => setSuccessMessage(null), 3000);
            } else {
                setError(data?.message || "Operation failed.");
                setTimeout(() => setError(null), 3000);
            }
        };

        socketService.on('userDeviceManager-add-response', handleResponse);
        socketService.on('userDeviceManager-edit-response', handleResponse);
        socketService.on('userDeviceManager-delete-response', handleResponse);
        socketService.on('userDeviceManager-toggle-response', handleResponse);
        
        socketService.on('globalUserDeviceRefresh', () => {
            if (selectedUserId) fetchUserAndDevices(selectedUserId);
        });

        // 🔥 NEW: Transaction History Listener
        socketService.on('device_transactions_response', (data) => {
            setTransactionList(data);
            setLoadingTrx(false);
            setShowTrxModal(true); // Open Modal
        });

        // Mode Lock Response Listener
        socketService.on('admin-update-mode-locks-response', (data) => {
            if (data?.success) {
                setSuccessMessage('Mode locks updated successfully!');
                setTimeout(() => setSuccessMessage(null), 3000);
            } else {
                setError(data?.message || 'Failed to update mode locks.');
                setTimeout(() => setError(null), 3000);
            }
        });

        return () => {
            socketService.off('usersList');
            socketService.off('userDeviceManager-userData');
            socketService.off('userDeviceManager-add-response');
            socketService.off('userDeviceManager-edit-response');
            socketService.off('userDeviceManager-delete-response');
            socketService.off('userDeviceManager-toggle-response');
            socketService.off('globalUserDeviceRefresh');
            socketService.off('device_transactions_response');
            socketService.off('admin-update-mode-locks-response');
        };
    }, [selectedUserId, fetchUserAndDevices, activeDeviceForConfig, activeDeviceForAppSettings, activeDeviceForUSSD]);

    // --- 🔥 Real-time UI Update ---
    useEffect(() => {
        const handleDeviceUpdate = (updatedDevice) => {
            console.log("Socket Update Received for:", updatedDevice.deviceName);

            // ১. মেইন ডিভাইসের লিস্ট আপডেট
            setDevices((prevDevices) => 
                prevDevices.map((d) => (d._id === updatedDevice._id ? updatedDevice : d))
            );

            // ২. যদি USSD মডাল ওপেন থাকে, তবে সেটি ফোর্স আপডেট করা
            setActiveDeviceForUSSD((currentActiveDevice) => {
                if (currentActiveDevice && currentActiveDevice._id === updatedDevice._id) {
                    return { ...updatedDevice }; 
                }
                return currentActiveDevice;
            });
        };

        socketService.on('deviceUpdated', handleDeviceUpdate);

        return () => {
            socketService.off('deviceUpdated', handleDeviceUpdate);
        };
    }, []);

    useEffect(() => {
        if (usernameFromUrl && users.length > 0 && !selectedUserId) {
            const matchedUser = users.find(u => u.username === usernameFromUrl);
            if (matchedUser) {
                setSelectedUserId(matchedUser.id || matchedUser._id);
                fetchUserAndDevices(matchedUser.id || matchedUser._id);
            }
        }
    }, [usernameFromUrl, users, selectedUserId, fetchUserAndDevices]);

    // --- Action Handlers ---

    // --- 🔥 OTP Settings Functions 🔥 ---
    const handleOpenOtpModal = (device) => {
        setOtpDevice(device);
        setOtpForm({
            username: device.otpSetting?.username || '',
            blockusername: device.otpSetting?.blockusername || [],
            simNumber: device.otpSetting?.simNumber || '',
            status: device.otpSetting?.status || 'active'
        });
        setShowOtpModal(true);
    };

    const addBlockUser = () => {
        if (tempBlockUser.trim()) {
            setOtpForm({
                ...otpForm,
                blockusername: [...otpForm.blockusername, tempBlockUser.trim()]
            });
            setTempBlockUser('');
        }
    };

    const removeBlockUser = (index) => {
        const updatedList = otpForm.blockusername.filter((_, i) => i !== index);
        setOtpForm({ ...otpForm, blockusername: updatedList });
    };

    const handleSaveOtpSettings = () => {
        socketService.emit('updateDeviceOtpSettings', {
            deviceId: otpDevice._id,
            otpSetting: otpForm
        });
        setShowOtpModal(false);
        
        // Success মেসেজ দেখানো
        if (typeof showSuccess === "function") {
            showSuccess("OTP Settings Updated!");
        } else {
            alert("OTP Settings Updated!");
        }
    };
    // ----------------------------------------

    // 🔥 NEW: View Transactions Handler
    const handleViewTransactions = (deviceName, simSlot) => {
        // নতুন পেজে নিয়ে যাবে
        navigate(`/device-transactions?deviceName=${deviceName}&simSlot=${simSlot}&username=${usernameFromUrl}`);
    };

    const handleOpenModeLockModal = (device) => {
        setModeLockDevice(device);
        setModeLockForm({
            issamiauto: device.issamiauto || false,
            isstanderpaid: device.isstanderpaid || false,
            isadvancepaid: device.isadvancepaid || false
        });
        setShowModeLockModal(true);
    };

    const handleSaveModeLocks = () => {
        if (!modeLockDevice) return;
        socketService.emit('admin-update-mode-locks', {
            deviceId: modeLockDevice._id,
            issamiauto: modeLockForm.issamiauto,
            isstanderpaid: modeLockForm.isstanderpaid,
            isadvancepaid: modeLockForm.isadvancepaid
        });
        setShowModeLockModal(false);
    };

    const handleAutoOn = (deviceId, simSlot, typeId) => {
        // ১. সার্ভারে রিকোয়েস্ট পাঠানো
        socketService.emit('enableAutoUssd', { deviceId, simSlot, typeId });

        // ২. সাথে সাথে UI আপডেট করে দেওয়া (Optimistic Update)
        setActiveDeviceForUSSD(prevState => {
            if (!prevState || prevState._id !== deviceId) return prevState;

            // ডাটা কপি করা হচ্ছে যাতে রিয়েক্ট বোঝে নতুন আপডেট এসেছে
            const newState = JSON.parse(JSON.stringify(prevState));
            
            const types = simSlot === 'sim1' ? newState.sim1.types : newState.sim2.types;
            const target = types.find(t => t._id === typeId);
            
            if (target) {
                target.status = 'show';
                target.autoDisableAt = Date.now() + 300000; 
            }
            
            return newState;
        });
    };

    const handleAddSubmit = (e) => {
        e.preventDefault();
        if (!selectedUserId) return alert("Please select a user first.");
        setLoading(true);

        const payload = {
            userId: selectedUserId,
            deviceName: addForm.deviceName,
            sim1_balance: parseFloat(addForm.sim1_balance) || 0,
            sim2_balance: parseFloat(addForm.sim2_balance) || 0,
            sim1: { sim: addForm.sim1, types: [] },
            sim2: { sim: addForm.sim2, types: [] }
        };

        socketService.emit('userDeviceManager-addDevice', payload);
        setAddForm(initialAddForm);
    };

    const handleToggleStatus = (deviceId, currentStatus) => {
        const newStatus = currentStatus === 'on' ? 'off' : 'on';
        socketService.emit('userDeviceManager-toggleStatus', { deviceId, newStatus });
    };

    const handleDelete = (deviceId) => {
        if (window.confirm("Are you sure you want to delete this device?")) {
            socketService.emit('userDeviceManager-deleteDevice', { deviceId });
        }
    };

    const openEditModal = (device) => {
        const sim1Val = typeof device.sim1 === 'object' ? device.sim1.sim : device.sim1;
        const sim2Val = typeof device.sim2 === 'object' ? device.sim2.sim : device.sim2;

        setEditingDevice({ 
            ...device, 
            id: device._id,
            sim1_number_edit: sim1Val,
            sim2_number_edit: sim2Val,
            sim1_balance: device.sim1_balance,
            sim2_balance: device.sim2_balance
        });
        setShowEditModal(true);
    };

    const handleEditSave = (e) => {
        e.preventDefault();
        setLoading(true);
        const getUpdatedSimObject = (oldSimData, newNumber) => {
            if (typeof oldSimData === 'object' && oldSimData !== null) {
                return { ...oldSimData, sim: newNumber };
            }
            return { sim: newNumber, types: [] };
        };
        const updatedDevice = {
            ...editingDevice,
            sim1_balance: parseFloat(editingDevice.sim1_balance) || 0,
            sim2_balance: parseFloat(editingDevice.sim2_balance) || 0,
            sim1: getUpdatedSimObject(editingDevice.sim1, editingDevice.sim1_number_edit),
            sim2: getUpdatedSimObject(editingDevice.sim2, editingDevice.sim2_number_edit)
        };
        delete updatedDevice.sim1_number_edit;
        delete updatedDevice.sim2_number_edit;
        socketService.emit('userDeviceManager-editDevice', updatedDevice);
    };

    const handleSaveUSSD = (e) => {
        e.preventDefault();
        const stepsArray = newUSSDForm.steps.split(',').map(s => s.trim()).filter(s => s !== '');
        if (stepsArray.length === 0) return alert("Please enter at least one step.");

        const updatedDevice = JSON.parse(JSON.stringify(activeDeviceForUSSD));
        const targetSimKey = ussdSimTab; 

        if (!updatedDevice[targetSimKey] || typeof updatedDevice[targetSimKey] !== 'object') {
            const existingNumber = typeof updatedDevice[targetSimKey] === 'string' ? updatedDevice[targetSimKey] : '';
            updatedDevice[targetSimKey] = { sim: existingNumber, types: [] };
        }
        if (!updatedDevice[targetSimKey].types) updatedDevice[targetSimKey].types = [];

        const newUSSDObject = { 
            type: newUSSDForm.typeName, 
            steps: stepsArray,
            status: newUSSDForm.status 
        };

        if (editingUSSDIndex !== null) {
            updatedDevice[targetSimKey].types[editingUSSDIndex] = newUSSDObject;
        } else {
            updatedDevice[targetSimKey].types.push(newUSSDObject);
        }
        socketService.emit('userDeviceManager-editDevice', updatedDevice);
        setNewUSSDForm({ typeName: '', steps: '', status: 'show' });
        setEditingUSSDIndex(null);
    };

    const handleEditUSSDClick = (index, item) => {
        setNewUSSDForm({ 
            typeName: item.type, 
            steps: item.steps.join(', '),
            status: item.status || 'show'
        });
        setEditingUSSDIndex(index);
    };

    const toggleUSSDStatus = (index) => {
        const updatedDevice = JSON.parse(JSON.stringify(activeDeviceForUSSD));
        const targetSimKey = ussdSimTab;
        
        if (!updatedDevice[targetSimKey] || !updatedDevice[targetSimKey].types) return;

        const currentItem = updatedDevice[targetSimKey].types[index];
        const newStatus = (currentItem.status === 'hide') ? 'show' : 'hide';
        
        updatedDevice[targetSimKey].types[index].status = newStatus;
        socketService.emit('userDeviceManager-editDevice', updatedDevice);
    };

    const handleDeleteUSSD = (index) => {
        if (!window.confirm("Delete this USSD config?")) return;
        const updatedDevice = JSON.parse(JSON.stringify(activeDeviceForUSSD));
        updatedDevice[ussdSimTab].types.splice(index, 1);
        socketService.emit('userDeviceManager-editDevice', updatedDevice);
        if (editingUSSDIndex === index) {
            setEditingUSSDIndex(null);
            setNewUSSDForm({ typeName: '', steps: '', status: 'show' });
        }
    };

    const handleCancelEdit = () => {
        setEditingUSSDIndex(null);
        setNewUSSDForm({ typeName: '', steps: '', status: 'show' });
    };

    const handleAddConfig = (e) => {
        e.preventDefault();
        const updatedConfigs = [...(activeDeviceForConfig.remoteAppConfigs || [])];
        const appIdx = updatedConfigs.findIndex(a => a.appName.toLowerCase() === newConfigForm.appName.toLowerCase());
        const newEvent = { eventName: newConfigForm.eventName, time: parseInt(newConfigForm.time), status: 'pending' };
        if (appIdx > -1) {
            updatedConfigs[appIdx].events.push(newEvent);
        } else {
            updatedConfigs.push({ appName: newConfigForm.appName, packageName: newConfigForm.packageName, events: [newEvent] });
        }
        socketService.emit('userDeviceManager-updateConfigs', { deviceId: activeDeviceForConfig._id, configs: updatedConfigs });
        setNewConfigForm({ appName: '', packageName: '', eventName: '', time: 5 });
    };

    const deleteConfigEvent = (appIdx, eventIdx) => {
        if (!window.confirm("Delete this event?")) return;
        const updatedConfigs = JSON.parse(JSON.stringify(activeDeviceForConfig.remoteAppConfigs));
        updatedConfigs[appIdx].events.splice(eventIdx, 1);
        if (updatedConfigs[appIdx].events.length === 0) updatedConfigs.splice(appIdx, 1);
        socketService.emit('userDeviceManager-updateConfigs', { deviceId: activeDeviceForConfig._id, configs: updatedConfigs });
    };

    const sendRemoteCommand = (action, appName, eventName) => {
        socketService.emit('userDeviceManager-sendRemoteControl', { deviceId: activeDeviceForConfig._id, action, appName, eventName });
    };

    const openEventModal = (type, appIdx, eventIdx = null, currentData = null) => {
        setEventModal({ show: true, type, appIdx, eventIdx, data: currentData || { eventName: '', time: 5 } });
    };

    const handleSaveEventConfig = (e) => {
        e.preventDefault();
        const updatedConfigs = JSON.parse(JSON.stringify(activeDeviceForConfig.remoteAppConfigs));
        const { appIdx, eventIdx, type, data } = eventModal;
        if (type === 'edit') {
            const oldStatus = updatedConfigs[appIdx].events[eventIdx].status;
            updatedConfigs[appIdx].events[eventIdx] = { eventName: data.eventName, time: parseInt(data.time), status: oldStatus };
        } else {
            updatedConfigs[appIdx].events.push({ eventName: data.eventName, time: parseInt(data.time), status: 'pending' });
        }
        socketService.emit('userDeviceManager-updateConfigs', { deviceId: activeDeviceForConfig._id, configs: updatedConfigs });
    };

    const handleAddAppSetting = (e) => {
        e.preventDefault();
        const updatedSettings = [...(activeDeviceForAppSettings.AppSettings || [])];
        if (updatedSettings.some(a => a.packageName === newAppSettingForm.packageName)) return alert("Duplicate package!");
        
        updatedSettings.push({ ...newAppSettingForm, isEnabled: true });
        
        socketService.emit('userDeviceManager-updateAppSettings', { deviceId: activeDeviceForAppSettings._id, appSettings: updatedSettings });
        
        setNewAppSettingForm({ appName: '', packageName: '', isNagad: false, isBkash: false });
    };

    const toggleAppSetting = (index) => {
        const updatedSettings = [...activeDeviceForAppSettings.AppSettings];
        updatedSettings[index].isEnabled = !updatedSettings[index].isEnabled;
        socketService.emit('userDeviceManager-updateAppSettings', { deviceId: activeDeviceForAppSettings._id, appSettings: updatedSettings });
    };

    const toggleIsNagad = (index) => {
        const updatedSettings = [...activeDeviceForAppSettings.AppSettings];
        updatedSettings[index].isNagad = !updatedSettings[index].isNagad;
        socketService.emit('userDeviceManager-updateAppSettings', { deviceId: activeDeviceForAppSettings._id, appSettings: updatedSettings });
    };

    const toggleIsBkash = (index) => {
        const updatedSettings = [...activeDeviceForAppSettings.AppSettings];
        updatedSettings[index].isBkash = !updatedSettings[index].isBkash;
        socketService.emit('userDeviceManager-updateAppSettings', { deviceId: activeDeviceForAppSettings._id, appSettings: updatedSettings });
    };

    const deleteAppSetting = (index) => {
        if (!window.confirm("Remove app?")) return;
        const updatedSettings = [...activeDeviceForAppSettings.AppSettings];
        updatedSettings.splice(index, 1);
        socketService.emit('userDeviceManager-updateAppSettings', { deviceId: activeDeviceForAppSettings._id, appSettings: updatedSettings });
    };

    // Styles
    const pageStyles = `
        .main-content-area { background-color: #f4f7fa; min-height: 100vh; padding: 20px; width: 100%; font-family: 'Inter', sans-serif; }
        .nav-tabs-container { display: flex; background: #ffffff; padding: 15px 20px 0 20px; border-bottom: 1px solid #e2e8f0; margin-bottom: 20px; gap: 15px; border-radius: 12px 12px 0 0; }
        .nav-tab-item { padding: 10px 25px; font-size: 13px; font-weight: 600; color: #64748b; cursor: pointer; border: 1px solid transparent; border-radius: 6px; transition: all 0.2s ease; text-transform: uppercase; margin-bottom: 15px; }
        .nav-tab-item:hover { color: #0284c7; background: #f8fafc; }
        .nav-tab-item.active { color: #0284c7; border: 1px solid #0284c7; background: #f0f9ff; font-weight: 800; }
        .section-title { color: #334155; font-weight: 700; }
        .count-badge { background: #fff; padding: 5px 15px; border-radius: 50px; border: 1px solid #e2e8f0; font-size: 13px; font-weight: 600; }
        .count-badge span { color: #0284c7; font-weight: 800; }
        .filter-card { background: #ffffff; padding: 20px; border-radius: 12px; }
        .field-label { font-size: 11px; font-weight: 700; color: #64748b; margin-bottom: 5px; text-transform: uppercase; }
        .modern-input { background: #f8fafc; border: 1px solid #cbd5e1; padding: 8px 12px; border-radius: 8px; font-size: 13px; width: 100%; outline: none; transition: 0.2s; }
        .modern-input:focus { border-color: #0284c7; background: #fff; }
        .btn-apply { background: #0284c7; color: white; border-radius: 8px; font-size: 13px; border: none; transition: 0.3s; }
        .btn-apply:hover { background: #0369a1; }
        .btn-reset { background: #f1f5f9; color: #475569; border: 1px solid #cbd5e1; border-radius: 8px; font-size: 13px; }
        .table-container { background: #ffffff; border-radius: 12px; overflow: hidden; }
        .custom-zebra-table { width: 100%; border-collapse: collapse; }
        .custom-zebra-table thead { background: #e2e8f0; color: #475569; }
        .custom-zebra-table th { padding: 14px 15px; font-size: 11px; font-weight: 800; text-transform: uppercase; border-bottom: 2px solid #cbd5e1; text-align: left; }
        .custom-zebra-table tbody tr:nth-child(even) { background-color: #f8fafc; }
        .custom-zebra-table tbody tr:hover { background-color: #edf2f7 !important; }
        .custom-zebra-table td { padding: 12px 15px; vertical-align: middle; border-bottom: 1px solid #edf2f7; }
        .user-primary { color: #0369a1; font-weight: 700; font-size: 16px; }
        .device-secondary { font-size: 10px; color: #64748b; font-weight: 800; background: #e2e8f0; display: inline-block; padding: 1px 6px; border-radius: 4px; margin-top: 3px; }
        .sim-num { color: #1e293b; font-weight: 700; font-size: 13px; }
        .badge-status { padding: 4px 12px; border-radius: 6px; font-size: 11px; font-weight: 700; border: 1px solid transparent; text-transform: capitalize; }
        .bg-seen { background: #f0fdf4; color: #16a34a; border-color: #bbf7d0; }
        .bg-fake { background: #fee2e2; color: #dc2626; border-color: #fecaca; }
        .custom-modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.7); z-index: 99999 !important; display: flex; justify-content: center; align-items: flex-start; padding-top: 60px; overflow-y: auto; }
        .custom-modal-dialog { background: #fff; width: 90%; max-width: 550px; margin: 0 auto 50px auto; border-radius: 12px; box-shadow: 0 20px 40px rgba(0,0,0,0.4); position: relative; animation: slideUp 0.3s ease-out; display: flex; flex-direction: column; }
        .custom-modal-dialog.modal-lg { max-width: 800px; }
        .modal-header { padding: 15px 20px; border-bottom: 1px solid #f1f5f9; display: flex; align-items: center; justify-content: space-between; background: #ffffff; border-radius: 12px 12px 0 0; }
        .modal-body { padding: 20px; overflow-x: hidden; }
        @keyframes slideUp { from { transform: translateY(-20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
    `;

    return (
        <Layout>
            <style>{pageStyles}</style>

            <div className="main-content-area py-3 px-10">
                
                {usernameFromUrl && selectedUserId ? (
                    <div className="bg-white rounded-top shadow-sm mb-4">
                        <div className="nav-tabs-container mb-0">
                            <div className="nav-tab-item" onClick={() => navigate(`/payment_send?username=${usernameFromUrl}`)}>📤 Payment Send</div>
                            <div className="nav-tab-item" onClick={() => navigate(`/appreceive_user?username=${usernameFromUrl}`)}>📥 App Receive</div>
                            <div className="nav-tab-item active" onClick={() => {}}>📱 User Devices</div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center p-3">
                             <h4 className="section-title mb-0" style={{fontSize: '18px'}}>User Manager: <span className="text-dark">{usernameFromUrl}</span></h4>
                            <div className="count-badge">Total Devices: <span>{devices.length}</span></div>
                        </div>
                    </div>
                ) : (
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h5 className="section-title m-0">📱 User Device Manager</h5>
                        {/* Ekhane button ta add kora hoyese */}
                <button className="btn btn-outline-primary btn-sm fw-bold" onClick={() => setShowSmsDocModal(true)}>
                    📱 SMS Commands Guide
                </button>
                        <div className="count-badge">Total Devices: <span>{devices.length}</span></div>
                    </div>
                )}

                {successMessage && <div className="alert bg-seen border-0 mb-3 small fw-bold">✅ {successMessage}</div>}
                {error && <div className="alert bg-fake border-0 mb-3 small fw-bold text-white">❌ {error}</div>}

                {!usernameFromUrl && (
                    <div className="filter-card shadow-sm border-0 mb-4">
                        <div className="row g-2 align-items-end">
                            <div className="col-md-7">
                                <label className="field-label">SELECT USER ACCOUNT</label>
                                <select className="modern-input" value={selectedUserId} onChange={(e) => { setSelectedUserId(e.target.value); fetchUserAndDevices(e.target.value); }}>
                                    <option value="">-- Choose User --</option>
                                    {displayableUsers.map(u => <option key={u.id} value={u.id}>{u.username}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>
                )}

                {selectedUserId && (
                    <>
                        <div className="filter-card shadow-sm border-0 mb-4">
                            <h6 className="field-label mb-3" style={{fontSize: '13px', color: '#1e293b'}}>ADD NEW DEVICE</h6>
                            <form onSubmit={handleAddSubmit} className="row g-2">
                                <div className="col-md-2"><label className="field-label">DEVICE NAME</label><input type="text" className="modern-input" placeholder="Name..." value={addForm.deviceName} onChange={(e) => setAddForm({...addForm, deviceName: e.target.value})} required /></div>
                                <div className="col-md-2"><label className="field-label">SIM 1 NUMBER</label><input type="text" className="modern-input" placeholder="017..." value={addForm.sim1} onChange={(e) => setAddForm({...addForm, sim1: e.target.value})} /></div>
                                <div className="col-md-2"><label className="field-label">SIM 1 BALANCE</label><input type="number" className="modern-input" placeholder="0.00" value={addForm.sim1_balance} onChange={(e) => setAddForm({...addForm, sim1_balance: e.target.value})} /></div>
                                <div className="col-md-2"><label className="field-label">SIM 2 NUMBER</label><input type="text" className="modern-input" placeholder="019..." value={addForm.sim2} onChange={(e) => setAddForm({...addForm, sim2: e.target.value})} /></div>
                                <div className="col-md-2"><label className="field-label">SIM 2 BALANCE</label><input type="number" className="modern-input" placeholder="0.00" value={addForm.sim2_balance} onChange={(e) => setAddForm({...addForm, sim2_balance: e.target.value})} /></div>
                                <div className="col-md-2"><button type="submit" className="btn btn-apply fw-bold w-100" style={{height: '38px'}} disabled={loading}>Register</button></div>

                                <div className="col-md-2">
            <button 
                type="button" // এটি অবশ্যই 'button' টাইপ হতে হবে যেন ফরম সাবমিট না হয়
                className="btn btn-success fw-bold w-100 shadow-sm" 
                style={{ height: '38px' }}
                onClick={handleAddTemplateDevice}
                title="অটো কনফিগার করা ডিভাইস অ্যাড করুন"
            >
                <i className="fas fa-magic me-1"></i> Auto Add
            </button>
        </div>
                
                            </form>
                        </div>

                        <div className="table-container shadow-sm border-0 mb-3">
                            <div className="table-responsive">
                                <table className="custom-zebra-table">
                                    <thead><tr><th className="ps-4">DEVICE INFO</th><th>SIM 1 CONFIGURATION</th><th>SIM 2 CONFIGURATION</th><th className="text-center">STATUS</th><th className="text-end pe-4">ACTIONS</th></tr></thead>
                                    <tbody>
                                        {devices.length === 0 ? (<tr><td colSpan="5" className="text-center py-5 opacity-50">No devices found.</td></tr>) : devices.map((device) => (
                                            <tr key={device._id}>
                                               
<td className="ps-4">
    <div className="user-primary">{device.deviceName}</div>
    <div className="device-secondary text-uppercase">ID: {device._id.slice(-6)}</div>
    
    {/* 🔥 অনলাইন স্ট্যাটাস (প্রথম লাইন) 🔥 */}
    {device.mobileOnline && (
        <div className="mt-1 d-flex align-items-center">
            <span className="badge bg-success me-1" style={{fontSize: '8px'}}>ONLINE</span>
            <span style={{fontSize: '9px', color: '#16a34a', fontWeight: 'bold'}}>
                ⏳ {device.lastOnlineTime ? moment(device.lastOnlineTime).fromNow(true) : 'Just now'}
            </span>
        </div>
    )}

    {/* 🔥 ব্যাটারি স্ট্যাটাস (নিচের লাইন) 🔥 */}
    {device.batteryPercentage !== undefined && device.batteryPercentage !== null && (
        <div className="mt-1">
            <span className="badge bg-light text-dark border d-inline-flex align-items-center" title="Battery Status" style={{fontSize: '9px', padding: '2px 6px'}}>
                🔋 {device.batteryPercentage}% 
                {device.batteryUpdatedAt && (
                    <small className="ms-1 text-muted" style={{ fontSize: "8px" }}>
                        ({moment(device.batteryUpdatedAt).fromNow()})
                    </small>
                )}
            </span>
        </div>
    )}
</td>


                                                <td>
                                                    <div className="sim-num">{typeof device.sim1 === 'object' ? device.sim1.sim : device.sim1 || 'N/A'}</div>
                                                    {/* 🔥 UPDATED: Show fetched SMS Balance if available */}
                                                    <div className="time-muted">
                                                        BAL: ৳{device.sim1?.currentBalance || device.sim1_balance?.toFixed(2) || '--'}
                                                    </div>
                                                    {device.sim1 && device.sim1.types && device.sim1.types.length > 0 && (<span className="badge bg-light text-dark border mt-1" style={{fontSize: '9px'}}>⚙️ {device.sim1.types.length} USSD Configs</span>)}
                                                    
                                                    <div className="mt-1">
                                                        <button 
                                                            className="btn btn-sm btn-outline-primary py-0 px-2" 
                                                            style={{fontSize: '10px'}}
                                                            onClick={() => handleViewTransactions(device.deviceName, '0')}
                                                            disabled={loadingTrx}
                                                        >
                                                            {loadingTrx ? 'Loading...' : '👁️ View Trx'}
                                                        </button>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="sim-num">{typeof device.sim2 === 'object' ? device.sim2.sim : device.sim2 || 'N/A'}</div>
                                                    {/* 🔥 UPDATED: Show fetched SMS Balance if available */}
                                                    <div className="time-muted">
                                                        BAL: ৳{device.sim2?.currentBalance || device.sim2_balance?.toFixed(2) || '--'}
                                                    </div>
                                                    {device.sim2 && device.sim2.types && device.sim2.types.length > 0 && (<span className="badge bg-light text-dark border mt-1" style={{fontSize: '9px'}}>⚙️ {device.sim2.types.length} USSD Configs</span>)}
                                                    
                                                    <div className="mt-1">
                                                        <button 
                                                            className="btn btn-sm btn-outline-primary py-0 px-2" 
                                                            style={{fontSize: '10px'}}
                                                            onClick={() => handleViewTransactions(device.deviceName, '1')}
                                                            disabled={loadingTrx}
                                                        >
                                                            {loadingTrx ? 'Loading...' : '👁️ View Trx'}
                                                        </button>
                                                    </div>
                                                </td>
                                                <td className="text-center"><span className={`badge-status ${device.status === 'on' ? 'bg-seen' : 'bg-fake'}`}>{device.status === 'on' ? 'Active' : 'Offline'}</span></td>
                                                <td className="text-end pe-4">
                                                    <div className="d-flex gap-2 justify-content-end align-items-center">
                                                        <button className={`btn btn-sm py-1 px-3 fw-bold ${device.status === 'on' ? 'btn-outline-danger' : 'btn-outline-success'}`} style={{fontSize: '11px'}} onClick={() => handleToggleStatus(device._id, device.status)}>{device.status === 'on' ? 'STOP' : 'START'}</button>
                                                        {isMainAdmin && (
                                                            <button
                                                                className={`btn btn-sm fw-bold shadow-sm ${(device.issamiauto || device.isstanderpaid || device.isadvancepaid) ? 'btn-danger' : 'btn-outline-secondary'}`}
                                                                onClick={() => handleOpenModeLockModal(device)}
                                                                title="Mode Lock Settings"
                                                            >
                                                                🔒 Modes
                                                            </button>
                                                        )}
                                                        <button className="btn btn-sm btn-light border" onClick={() => {setActiveDeviceForUSSD(device); setShowUSSDModal(true);}} title="USSD Configuration">🤖 USSD</button>
                                                        <button className="btn btn-sm btn-light border" onClick={() => {setActiveDeviceForAppSettings(device); setShowAppSettingsModal(true);}} title="App Settings">📱 Apps</button>
                                                        <button className="btn btn-sm btn-light border" onClick={() => {setActiveDeviceForConfig(device); setShowConfigModal(true);}} title="Remote Config">⚙️</button>
     {/* 🔥 OTP Button (Dynamic Color based on Status) 🔥 */}
    {isMainAdmin && (
        <button 
            // স্ট্যাটাস active থাকলে 'btn-success' (সবুজ), না হলে 'btn-outline-secondary' (ধূসর)
            className={`btn btn-sm shadow-sm ms-1 ${device.otpSetting?.status === 'active' ? 'btn-success' : 'btn-outline-secondary'}`}
            onClick={() => handleOpenOtpModal(device)}
            title="OTP Settings"
        >
            <i className="fas fa-shield-alt me-1"></i> OTP
        </button>
    )}                                        <button className="btn btn-sm btn-light border" onClick={() => openEditModal(device)}>✏️</button>
                                                        {/* Force Restart Accessibility */}
<button 
    className="btn btn-sm btn-outline-warning shadow-sm ms-1" 
    onClick={() => handleDeviceAction(device, 'forceRestartAccessibilityService')} 
    title="Force Restart Accessibility"
>
    <i className="fas fa-universal-access me-1"></i> Acc
</button>

{/* Mobile Restart */}
<button 
    className="btn btn-sm btn-outline-danger shadow-sm ms-1" 
    onClick={() => handleDeviceAction(device, 'mobileRestart')} 
    title="Mobile Restart"
>
    <i className="fas fa-power-off me-1"></i> Mob
</button>
                                                        <button className="btn btn-sm btn-light border text-danger" onClick={() => handleDelete(device._id)}>🗑️</button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>
                )}
            </div>

            {/* USSD Modal */}
            {showUSSDModal && activeDeviceForUSSD && (
                <div className="custom-modal-overlay">
                    <div className="custom-modal-dialog modal-lg">
                        <div className="custom-modal-content">
                            <div className="modal-header bg-light">
                                <h6 className="m-0 fw-bold">🤖 USSD Config: {activeDeviceForUSSD.deviceName}</h6>
                                <button type="button" className="btn-close" onClick={() => setShowUSSDModal(false)}></button>
                            </div>
                            <div className="modal-body p-4">
                                <ul className="nav nav-tabs mb-4">
                                    <li className="nav-item"><button className={`nav-link ${ussdSimTab === 'sim1' ? 'active fw-bold' : ''}`} onClick={() => {setUssdSimTab('sim1'); handleCancelEdit();}}>SIM 1 ({activeDeviceForUSSD.sim1?.sim || activeDeviceForUSSD.sim1 || 'No Num'})</button></li>
                                    <li className="nav-item"><button className={`nav-link ${ussdSimTab === 'sim2' ? 'active fw-bold' : ''}`} onClick={() => {setUssdSimTab('sim2'); handleCancelEdit();}}>SIM 2 ({activeDeviceForUSSD.sim2?.sim || activeDeviceForUSSD.sim2 || 'No Num'})</button></li>
                                </ul>
                                <div className="bg-light p-3 rounded-3 mb-4">
                                    <label className="field-label mb-2 d-block">{editingUSSDIndex !== null ? `EDITING: USSD SEQUENCE #${editingUSSDIndex + 1}` : 'ADD NEW USSD SEQUENCE'}</label>
                                    <form onSubmit={handleSaveUSSD} className="row g-2 align-items-end">
                                        <div className="col-md-3">
                                            <label className="field-label">TYPE NAME</label>
                                            <input type="text" className="modern-input" placeholder="Type (e.g. CashOut)" value={newUSSDForm.typeName} onChange={e => setNewUSSDForm({...newUSSDForm, typeName: e.target.value})} required />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="field-label">USSD STEPS</label>
                                            <input type="text" className="modern-input" placeholder="Steps (*247#, 1, ...)" value={newUSSDForm.steps} onChange={e => setNewUSSDForm({...newUSSDForm, steps: e.target.value})} required />
                                        </div>
                                        
                                        {/* Status Dropdown */}
                                        <div className="col-md-2">
                                            <label className="field-label">STATUS</label>
                                            <select 
                                                className="modern-input" 
                                                value={newUSSDForm.status} 
                                                onChange={(e) => setNewUSSDForm({...newUSSDForm, status: e.target.value})}
                                            >
                                                <option value="show">Show</option>
                                                <option value="hide">Hide</option>
                                            </select>
                                        </div>

                                        <div className="col-md-3 d-flex gap-1">
                                            {editingUSSDIndex !== null && <button type="button" className="btn btn-light border w-50" onClick={handleCancelEdit}>Cancel</button>}
                                            <button type="submit" className={`btn w-100 ${editingUSSDIndex !== null ? 'btn-warning text-white' : 'btn-apply'}`}>{editingUSSDIndex !== null ? 'Update' : 'Add'}</button>
                                        </div>
                                    </form>
                                </div>
                                <table className="custom-zebra-table" style={{ tableLayout: 'fixed' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '20%' }}>TYPE NAME</th>
                                            <th style={{ width: '45%' }}>USSD STEPS</th>
                                            <th className="text-center" style={{ width: '20%' }}>STATUS / AUTO</th>
                                            <th className="text-end" style={{ width: '15%' }}>ACTION</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(!activeDeviceForUSSD[ussdSimTab] || !activeDeviceForUSSD[ussdSimTab].types || activeDeviceForUSSD[ussdSimTab].types.length === 0) ? (
                                            <tr><td colSpan="4" className="text-center py-4 opacity-50">No config.</td></tr>
                                        ) : activeDeviceForUSSD[ussdSimTab].types.map((item, idx) => (
                                            <tr key={idx} style={editingUSSDIndex === idx ? { backgroundColor: '#fffbeb' } : {}}>
                                                <td><div className="sim-num">{item.type}</div></td>
                                                <td><div className="time-muted">{item.steps.join(' → ')}</div></td>

                                                {/* Auto Button & Status Toggle Button */}
                                                <td className="text-center">
                                                    <div className="d-flex flex-column align-items-center gap-1">
                                                        <button
                                                            type="button"
                                                            className={`btn btn-sm fw-bold ${item.autoDisableAt > 0 ? 'btn-warning text-dark' : 'btn-outline-primary'}`}
                                                            style={{ fontSize: '10px', padding: '2px 5px', width: '75px' }}
                                                            onClick={() => handleAutoOn(activeDeviceForUSSD._id, ussdSimTab, item._id)}
                                                            disabled={item.autoDisableAt > 0}
                                                            title="Turn ON for 5 minutes then Auto OFF"
                                                        >
                                                            {item.autoDisableAt > 0 ? '⏳ Active' : '⚡ Auto 5m'}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className={`btn btn-sm text-white fw-bold ${item.status === 'hide' ? 'btn-danger' : 'btn-success'}`}
                                                            style={{ fontSize: '10px', padding: '2px 8px', width: '75px' }}
                                                            onClick={() => toggleUSSDStatus(idx)}
                                                        >
                                                            {(item.status || 'show').toUpperCase()}
                                                        </button>
                                                    </div>
                                                </td>

                                                <td className="text-end">
                                                    <button className="btn btn-sm btn-light border me-1" onClick={() => handleEditUSSDClick(idx, item)}>✏️</button>
                                                    <button className="btn btn-sm btn-light border text-danger" onClick={() => handleDeleteUSSD(idx)}>🗑️</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* App Settings Modal */}
            {showAppSettingsModal && activeDeviceForAppSettings && (
                <div className="custom-modal-overlay">
                    <div className="custom-modal-dialog modal-lg">
                        <div className="custom-modal-content">
                            <div className="modal-header bg-light"><h6 className="m-0 fw-bold">📱 App Settings: {activeDeviceForAppSettings.deviceName}</h6><button type="button" className="btn-close" onClick={() => setShowAppSettingsModal(false)}></button></div>
                            <div className="modal-body p-4">
                                <div className="bg-light p-3 rounded-3 mb-4">
                                    <label className="field-label mb-2 d-block">ADD NEW APP SETTING</label>
                                    <form onSubmit={handleAddAppSetting} className="row g-2 align-items-end">
                                        <div className="col-md-3"><input type="text" className="modern-input" placeholder="App Name" value={newAppSettingForm.appName} onChange={e => setNewAppSettingForm({...newAppSettingForm, appName: e.target.value})} required /></div>
                                        <div className="col-md-3"><input type="text" className="modern-input" placeholder="Package Name" value={newAppSettingForm.packageName} onChange={e => setNewAppSettingForm({...newAppSettingForm, packageName: e.target.value})} required /></div>
                                        <div className="col-md-2"><div className="form-check bg-white p-2 border rounded"><input className="form-check-input ms-0 me-2" type="checkbox" id="isNagadCheck" checked={newAppSettingForm.isNagad} onChange={e => setNewAppSettingForm({...newAppSettingForm, isNagad: e.target.checked})} /><label className="form-check-label small fw-bold" htmlFor="isNagadCheck" style={{fontSize: '11px'}}>Nagad?</label></div></div>
                                        <div className="col-md-2"><div className="form-check bg-white p-2 border rounded"><input className="form-check-input ms-0 me-2" type="checkbox" id="isBkashCheck" checked={newAppSettingForm.isBkash} onChange={e => setNewAppSettingForm({...newAppSettingForm, isBkash: e.target.checked})} /><label className="form-check-label small fw-bold" htmlFor="isBkashCheck" style={{fontSize: '11px'}}>Bkash?</label></div></div>
                                        <div className="col-md-2"><button type="submit" className="btn btn-apply w-100" style={{height: '38px'}}>Add App</button></div>
                                    </form>
                                </div>
                                <table className="custom-zebra-table">
                                    <thead><tr><th>APP NAME</th><th>PACKAGE NAME</th><th className="text-center">IS NAGAD?</th><th className="text-center">IS BKASH?</th><th className="text-center">STATUS</th><th className="text-end">ACTION</th></tr></thead>
                                    <tbody>
                                        {(!activeDeviceForAppSettings.AppSettings || activeDeviceForAppSettings.AppSettings.length === 0) ? (<tr><td colSpan="6" className="text-center py-4 opacity-50">No apps configured.</td></tr>) : activeDeviceForAppSettings.AppSettings.map((app, idx) => (
                                            <tr key={idx}>
                                                <td><div className="sim-num">{app.appName}</div></td><td><div className="time-muted">{app.packageName}</div></td>
                                                <td className="text-center"><div className="form-check form-switch d-inline-block"><input className="form-check-input" type="checkbox" checked={app.isNagad === true} onChange={() => toggleIsNagad(idx)} /></div></td>
                                                <td className="text-center"><div className="form-check form-switch d-inline-block"><input className="form-check-input" type="checkbox" checked={app.isBkash === true} onChange={() => toggleIsBkash(idx)} /></div></td>
                                                <td className="text-center"><div className="form-check form-switch d-inline-block"><input className="form-check-input" type="checkbox" checked={app.isEnabled} onChange={() => toggleAppSetting(idx)} /></div></td>
                                                <td className="text-end"><button className="btn btn-sm btn-light border text-danger" onClick={() => deleteAppSetting(idx)}>🗑️ Remove</button></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Remote Config Modal */}
            {showConfigModal && activeDeviceForConfig && (
                <div className="custom-modal-overlay">
                    <div className="custom-modal-dialog modal-lg">
                        <div className="custom-modal-content">
                            <div className="modal-header bg-light"><h6 className="m-0 fw-bold">⚙️ Remote Automation: {activeDeviceForConfig.deviceName}</h6><button type="button" className="btn-close" onClick={() => setShowConfigModal(false)}></button></div>
                            <div className="modal-body p-4">
                                <div className="bg-light p-3 rounded-3 mb-4"><form onSubmit={handleAddConfig} className="row g-2"><div className="col-md-3"><input type="text" className="modern-input" placeholder="App Name" value={newConfigForm.appName} onChange={e => setNewConfigForm({...newConfigForm, appName: e.target.value})} required /></div><div className="col-md-3"><input type="text" className="modern-input" placeholder="Package" value={newConfigForm.packageName} onChange={e => setNewConfigForm({...newConfigForm, packageName: e.target.value})} required /></div><div className="col-md-3"><input type="text" className="modern-input" placeholder="Event" value={newConfigForm.eventName} onChange={e => setNewConfigForm({...newConfigForm, eventName: e.target.value})} required /></div><div className="col-md-1"><input type="number" className="modern-input" placeholder="Sec" value={newConfigForm.time} onChange={e => setNewConfigForm({...newConfigForm, time: e.target.value})} required /></div><div className="col-md-2"><button type="submit" className="btn btn-apply w-100">Add</button></div></form></div>
                                <table className="custom-zebra-table">
                                    <thead><tr><th>APP & PACKAGE</th><th>EVENT</th><th>STATUS</th><th className="text-end">ACTION</th></tr></thead>
                                    <tbody>
                                        {(!activeDeviceForConfig.remoteAppConfigs || activeDeviceForConfig.remoteAppConfigs.length === 0) ? (<tr><td colSpan="4" className="text-center py-4 opacity-50">No configs found.</td></tr>) : activeDeviceForConfig.remoteAppConfigs.map((app, appIdx) => app.events.map((ev, evIdx) => (
                                            <tr key={`${appIdx}-${evIdx}`}>
                                                <td><div className="sim-num">{app.appName}</div><div className="time-muted">{app.packageName}</div>{evIdx === 0 && <button className="btn btn-sm btn-link p-0 mt-1" style={{fontSize: '10px'}} onClick={() => openEventModal('add', appIdx)}>+ Add Event</button>}</td>
                                                <td><div className="sim-num">{ev.eventName}</div></td>
                                                <td><span className={`badge-status ${ev.status === 'successful' ? 'bg-seen' : 'bg-fake'}`}>{ev.status || 'pending'}</span></td>
                                                <td className="text-end"><button className="btn btn-sm btn-apply px-2" onClick={() => sendRemoteCommand("SetupRecoding", app.appName, ev.eventName)}>Setup</button><button className="btn btn-sm btn-light border px-2 mx-1" onClick={() => sendRemoteCommand("PlayRecoding", app.appName, ev.eventName)}>Try</button><button className="btn btn-sm btn-light border px-2 text-danger" onClick={() => sendRemoteCommand("DeleteRecoding", app.appName, ev.eventName)}>Del</button><button className="btn btn-sm btn-light border px-2 ms-1" onClick={() => openEventModal('edit', appIdx, evIdx, ev)}>✏️</button><button className="btn btn-sm text-danger" onClick={() => deleteConfigEvent(appIdx, evIdx)}>🗑️</button></td>
                                            </tr>
                                        )))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Event Modal */}
            {eventModal.show && (
                <div className="custom-modal-overlay">
                    <div className="custom-modal-dialog" style={{maxWidth: '350px'}}>
                        <div className="custom-modal-content">
                            <div className="modal-header bg-light py-2"><h6 className="m-0 fw-bold">{eventModal.type === 'edit' ? 'Edit Event' : 'Add New Event'}</h6><button type="button" className="btn-close small" onClick={() => setEventModal({...eventModal, show: false})}></button></div>
                            <form onSubmit={handleSaveEventConfig}>
                                <div className="modal-body p-3"><div className="mb-2"><label className="field-label">EVENT NAME</label><input type="text" className="modern-input" value={eventModal.data.eventName} onChange={(e) => setEventModal({...eventModal, data: {...eventModal.data, eventName: e.target.value}})} required /></div><div className="mb-2"><label className="field-label">Start</label><input type="number" className="modern-input" value={eventModal.data.time} onChange={(e) => setEventModal({...eventModal, data: {...eventModal.data, time: e.target.value}})} required /></div></div>
                                <div className="modal-footer py-2 border-0"><button type="button" className="btn btn-sm btn-light border" onClick={() => setEventModal({...eventModal, show: false})}>Cancel</button><button type="submit" className="btn btn-sm btn-apply">Save</button></div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Device Modal */}
            {showEditModal && (
                <div className="custom-modal-overlay">
                    <div className="custom-modal-dialog">
                        <div className="custom-modal-content">
                            <div className="modal-header bg-light"><h6 className="m-0 fw-bold">Edit Device: {editingDevice.deviceName}</h6><button type="button" className="btn-close" onClick={() => setShowEditModal(false)}></button></div>
                            <form onSubmit={handleEditSave}>
                                <div className="modal-body p-4">
                                    <div className="mb-3"><label className="field-label">DEVICE NAME</label><input type="text" className="modern-input" value={editingDevice.deviceName} onChange={(e) => setEditingDevice({...editingDevice, deviceName: e.target.value})} /></div>
                                    <div className="row g-2 mb-3"><div className="col-6"><label className="field-label">SIM 1 NUMBER</label><input type="text" className="modern-input" value={editingDevice.sim1_number_edit} onChange={(e) => setEditingDevice({...editingDevice, sim1_number_edit: e.target.value})} /></div><div className="col-6"><label className="field-label">SIM 1 BALANCE</label><input type="number" className="modern-input" value={editingDevice.sim1_balance} onChange={(e) => setEditingDevice({...editingDevice, sim1_balance: e.target.value})} /></div></div>
                                    <div className="row g-2"><div className="col-6"><label className="field-label">SIM 2 NUMBER</label><input type="text" className="modern-input" value={editingDevice.sim2_number_edit} onChange={(e) => setEditingDevice({...editingDevice, sim2_number_edit: e.target.value})} /></div><div className="col-6"><label className="field-label">SIM 2 BALANCE</label><input type="number" className="modern-input" value={editingDevice.sim2_balance} onChange={(e) => setEditingDevice({...editingDevice, sim2_balance: e.target.value})} /></div></div>
                                </div>
                                <div className="modal-footer border-0"><button type="button" className="btn btn-reset px-4" onClick={() => setShowEditModal(false)}>Cancel</button><button type="submit" className="btn btn-apply px-4">Update Device</button></div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* 🔥 NEW: TRANSACTION HISTORY MODAL */}
            {showTrxModal && (
                <div className="custom-modal-overlay" style={{ zIndex: 1055 }}>
                    <div className="custom-modal-dialog modal-lg">
                        <div className="custom-modal-content border-0 shadow-lg">
                            <div className="modal-header bg-dark text-white py-2">
                                <h6 className="modal-title">📊 Last 30 Transactions Log</h6>
                                <button type="button" className="btn-close btn-close-white" onClick={() => setShowTrxModal(false)}></button>
                            </div>
                            <div className="modal-body p-0">
                                <div className="table-responsive" style={{maxHeight: '400px', overflowY: 'auto'}}>
                                    <table className="custom-zebra-table" style={{fontSize: '12px'}}>
                                        <thead className="bg-light sticky-top">
                                            <tr>
                                                <th className="p-2">Date</th>
                                                <th className="p-2">Type</th>
                                                <th className="p-2">TrxID</th>
                                                <th className="p-2 text-end">Amount</th>
                                                <th className="p-2 text-end">Old Bal</th>
                                                <th className="p-2 text-end">New Bal</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {transactionList.length > 0 ? (
                                                transactionList.map((trx) => (
                                                    <tr key={trx._id}>
                                                        <td className="p-2">{moment(trx.date).format('DD/MM HH:mm')}</td>
                                                        <td className="p-2">
                                                            <span className={`badge ${
                                                                trx.type === 'Cash In' ? 'bg-success' : 
                                                                trx.type === 'Cash Out' ? 'bg-danger' : 'bg-secondary'
                                                            }`}>
                                                                {trx.type}
                                                            </span>
                                                        </td>
                                                        <td className="p-2 fw-bold">{trx.trxID}</td>
                                                        <td className="p-2 text-end fw-bold text-primary">৳{trx.amount}</td>
                                                        <td className="p-2 text-end text-muted">৳{trx.oldBalance}</td>
                                                        <td className="p-2 text-end fw-bold text-success">৳{trx.newBalance}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="6" className="text-center p-3 text-muted">
                                                        NO DATA FOUND
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer py-1">
                                <button type="button" className="btn btn-sm btn-secondary" onClick={() => setShowTrxModal(false)}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


{/* --- OTP Settings Modal --- */}
{showOtpModal && (
    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1100 }}>
        <div className="modal-dialog modal-md" style={{ marginTop: '80px' }}>
            <div className="modal-content border-0 shadow">
                <div className="modal-header bg-warning text-dark">
                    <h5 className="modal-title fw-bold">
                        <i className="bi bi-shield-lock-fill me-2"></i> 
                        OTP Settings - {otpDevice?.deviceName}
                    </h5>
                    <button type="button" className="btn-close" onClick={() => setShowOtpModal(false)}></button>
                </div>
                <div className="modal-body">
                    <div className="mb-3">
                        <label className="form-label fw-semibold">Target Username</label>
                        <input type="text" className="form-control" value={otpForm.username} onChange={(e) => setOtpForm({...otpForm, username: e.target.value})} placeholder="e.g. admin123" />
                    </div>

                    {/* 🔥 SIM Number Selection Dropdown 🔥 */}
                    <div className="mb-3">
                        <label className="form-label fw-semibold">Target SIM Number</label>
                        <select 
                            className="form-select" 
                            value={otpForm.simNumber} 
                            onChange={(e) => setOtpForm({...otpForm, simNumber: e.target.value})}
                        >
                            <option value="">Select a SIM</option>
                            {otpDevice?.sim1?.sim && <option value={otpDevice.sim1.sim}>Sim 1 ({otpDevice.sim1.sim})</option>}
                            {otpDevice?.sim2?.sim && <option value={otpDevice.sim2.sim}>Sim 2 ({otpDevice.sim2.sim})</option>}
                        </select>
                    </div>

                    <div className="mb-3">
                        <label className="form-label fw-semibold">Feature Status</label>
                        <select className="form-select" value={otpForm.status} onChange={(e) => setOtpForm({...otpForm, status: e.target.value})}>
                            <option value="active">Active (On)</option>
                            <option value="deactive">Deactive (Off)</option>
                        </select>
                    </div>

                    <hr />
                    <h6 className="fw-bold text-danger mb-3">Block User List</h6>
                    <div className="input-group mb-3">
                        <input 
                            type="text" 
                            className="form-control" 
                            placeholder="Type username to block..." 
                            value={tempBlockUser} 
                            onChange={(e) => setTempBlockUser(e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' && addBlockUser()}
                        />
                        <button className="btn btn-dark" onClick={addBlockUser}>Add</button>
                    </div>
                    
                    <div className="d-flex flex-wrap gap-2 p-2 border rounded bg-light min-vh-25">
                        {otpForm.blockusername.length === 0 && <span className="text-muted small">No blocked users.</span>}
                        {otpForm.blockusername.map((user, index) => (
                            <span key={index} className="badge bg-danger d-flex align-items-center p-2 shadow-sm">
                                {user} 
                                {/* 🔥 Delete Button (X icon) 🔥 */}
                                <button 
                                    type="button" 
                                    className="btn-close btn-close-white ms-2" 
                                    style={{ fontSize: '10px' }}
                                    onClick={() => removeBlockUser(index)}
                                    title="Remove User"
                                ></button>
                            </span>
                        ))}
                    </div>
                </div>
                <div className="modal-footer bg-light">
                    <button className="btn btn-secondary" onClick={() => setShowOtpModal(false)}>Cancel</button>
                    <button className="btn btn-success" onClick={handleSaveOtpSettings}>
                        <i className="bi bi-save me-1"></i> Save Changes
                    </button>
                </div>
            </div>
        </div>
    </div>
)}

{/* Mode Lock Modal */}
{showModeLockModal && modeLockDevice && (
    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1100 }}>
        <div className="modal-dialog modal-sm" style={{ marginTop: '100px' }}>
            <div className="modal-content border-0 shadow">
                <div className="modal-header bg-danger text-white py-2">
                    <h6 className="modal-title fw-bold">🔒 Mode Lock — {modeLockDevice.deviceName}</h6>
                    <button type="button" className="btn-close btn-close-white" onClick={() => setShowModeLockModal(false)}></button>
                </div>
                <div className="modal-body">
                    <p className="text-muted small mb-3">Lock করা mode গুলো Android app-এ ব্যবহার করা যাবে না।</p>
                    <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                        <span className="fw-semibold">Sami Auto</span>
                        <div className="form-check form-switch mb-0">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={modeLockForm.issamiauto}
                                onChange={(e) => setModeLockForm({ ...modeLockForm, issamiauto: e.target.checked })}
                                style={{ cursor: 'pointer', width: '40px', height: '20px' }}
                            />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                        <span className="fw-semibold">Stander Paid</span>
                        <div className="form-check form-switch mb-0">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={modeLockForm.isstanderpaid}
                                onChange={(e) => setModeLockForm({ ...modeLockForm, isstanderpaid: e.target.checked })}
                                style={{ cursor: 'pointer', width: '40px', height: '20px' }}
                            />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-2">
                        <span className="fw-semibold">Advance Paid</span>
                        <div className="form-check form-switch mb-0">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={modeLockForm.isadvancepaid}
                                onChange={(e) => setModeLockForm({ ...modeLockForm, isadvancepaid: e.target.checked })}
                                style={{ cursor: 'pointer', width: '40px', height: '20px' }}
                            />
                        </div>
                    </div>
                </div>
                <div className="modal-footer bg-light py-2">
                    <button className="btn btn-sm btn-secondary" onClick={() => setShowModeLockModal(false)}>Cancel</button>
                    <button className="btn btn-sm btn-danger fw-bold" onClick={handleSaveModeLocks}>
                        💾 Save Locks
                    </button>
                </div>
            </div>
        </div>
    </div>
)}

{/* SMS Commands Documentation Modal */}
{showSmsDocModal && (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
            <div className="modal-content shadow-lg border-0">
                <div className="modal-header bg-primary text-white py-2">
                    <h5 className="modal-title mb-0"><i className="bi bi-chat-text me-2"></i>📱 DebitPay অ্যাপের সকল SMS কমান্ডের লিস্ট</h5>
                    <button type="button" className="btn-close btn-close-white" onClick={() => setShowSmsDocModal(false)}></button>
                </div>
                <div className="modal-body">
                    <div className="alert alert-info py-2 small">
                        <strong>টিপস:</strong> নিচের কোড বক্সগুলোতে ক্লিক করলেই অটোমেটিক কপি হয়ে যাবে।
                    </div>

                    <div className="mb-3 border-bottom pb-2">
                        <h6 className="fw-bold text-dark">১. ইন্টারনেট স্ট্যাটাস চেক করা (Check Internet)</h6>
                        <p className="text-muted small mb-1">অ্যাপটির ফোনে ইন্টারনেট কানেকশন আছে কিনা তা জানার জন্য এই কমান্ডটি পাঠাতে হবে। অ্যাপটি আপনার নাম্বারে ইন্টারনেট স্ট্যাটাস (Connected বা Disconnected) রিপ্লাই দিবে।</p>
                        <div 
                            className="bg-light p-2 border rounded text-dark font-monospace user-select-all" 
                            style={{cursor: 'pointer'}}
                            onClick={() => { navigator.clipboard.writeText("Dabit-check-internet"); showSuccess("Command Copied!"); }}
                        >
                            Dabit-check-internet
                        </div>
                    </div>

                    <div className="mb-3 border-bottom pb-2">
                        <h6 className="fw-bold text-dark">২. মোবাইল রিস্টার্ট করা (Reboot Device)</h6>
                        <p className="text-muted small mb-1">দূর থেকে অ্যাপের ফোনটি রিস্টার্ট (Reboot) করার জন্য এই কমান্ডটি ব্যবহার করবেন। (Note: অ্যাপটির Device Owner পারমিশন থাকতে হবে)।</p>
                        <div 
                            className="bg-light p-2 border rounded text-dark font-monospace user-select-all" 
                            style={{cursor: 'pointer'}}
                            onClick={() => { navigator.clipboard.writeText("Dabit-mobileseRestart"); showSuccess("Command Copied!"); }}
                        >
                            Dabit-mobileseRestart
                        </div>
                    </div>

                    <div className="mb-3 border-bottom pb-2">
                        <h6 className="fw-bold text-dark">৩. ব্যাকগ্রাউন্ড অটো-রিলগিন করা (Background Auto-Relogin)</h6>
                        <p className="text-muted small mb-1">কোনো কারণে সকেট ডিসকানেক্ট হলে বা অ্যাপ নতুন করে লগইন করানোর প্রয়োজন হলে, ইউজারনেম, পাসওয়ার্ড এবং ডোমেইন কোড দিয়ে এই মেসেজটি পাঠাতে হবে।</p>
                        <div 
                            className="bg-light p-2 border rounded mb-1 text-dark font-monospace user-select-all" 
                            style={{cursor: 'pointer'}}
                            onClick={() => { navigator.clipboard.writeText("Dabit-relogin /u-[Username] /p-[Password] /C-[DomainCode] /d-[DeviceName]"); showSuccess("Command Format Copied!"); }}
                        >
                            Dabit-relogin /u-[Username] /p-[Password] /C-[DomainCode] /d-[DeviceName]
                        </div>
                        <div className="small text-muted mb-1">উদাহরণ:</div>
                        <div 
                            className="bg-light p-2 border rounded text-success font-monospace user-select-all" 
                            style={{cursor: 'pointer'}}
                            onClick={() => { navigator.clipboard.writeText("Dabit-relogin /u-admin123 /p-pass456 /C-DCode99 /d-MyPhone1"); showSuccess("Example Copied!"); }}
                        >
                            Dabit-relogin /u-admin123 /p-pass456 /C-DCode99 /d-MyPhone1
                        </div>
                    </div>

                    <div className="mb-3 border-bottom pb-2">
                        <h6 className="fw-bold text-dark">৪. নির্দিষ্ট ট্রানজেকশন আইডি (TrxID) দিয়ে SMS খোঁজা</h6>
                        <p className="text-muted small mb-1">Nagad বা bKash এর কোনো নির্দিষ্ট ট্রানজেকশন আইডি দিয়ে সেই ট্রানজেকশনের পুরো SMS-টি খুঁজে আপনার নাম্বারে ব্যাক পাওয়ার জন্য এই কমান্ডটি ব্যবহার করবেন।</p>
                        <div 
                            className="bg-light p-2 border rounded mb-1 text-dark font-monospace user-select-all" 
                            style={{cursor: 'pointer'}}
                            onClick={() => { navigator.clipboard.writeText("Dabit-getSMS_tr /s-[SenderName] /tr-[TrxID]"); showSuccess("Command Format Copied!"); }}
                        >
                            Dabit-getSMS_tr /s-[SenderName] /tr-[TrxID]
                        </div>
                        <div className="small text-muted mb-1">bKash এর উদাহরণ:</div>
                        <div 
                            className="bg-light p-2 border rounded mb-1 text-danger font-monospace user-select-all" 
                            style={{cursor: 'pointer'}}
                            onClick={() => { navigator.clipboard.writeText("Dabit-getSMS_tr /s-bKash /tr-DC99U1E71L"); showSuccess("bKash Example Copied!"); }}
                        >
                            Dabit-getSMS_tr /s-bKash /tr-DC99U1E71L
                        </div>
                        <div className="small text-muted mb-1">Nagad এর উদাহরণ:</div>
                        <div 
                            className="bg-light p-2 border rounded text-warning font-monospace user-select-all" 
                            style={{cursor: 'pointer'}}
                            onClick={() => { navigator.clipboard.writeText("Dabit-getSMS_tr /s-Nagad /tr-751FV1QJ"); showSuccess("Nagad Example Copied!"); }}
                        >
                            Dabit-getSMS_tr /s-Nagad /tr-751FV1QJ
                        </div>
                    </div>

                    <div className="mb-3 pb-2">
                        <h6 className="fw-bold text-dark">৫. নির্দিষ্ট তারিখ ও সময় (Date Range) অনুযায়ী SMS খোঁজা</h6>
                        <p className="text-muted small mb-1">কোনো নির্দিষ্ট সময়ের মধ্যে আসা সমস্ত SMS খুঁজে বের করে আপনার নাম্বারে আনার জন্য এটি ব্যবহার করবেন।</p>
                        <div 
                            className="bg-light p-2 border rounded mb-1 text-dark font-monospace user-select-all" 
                            style={{cursor: 'pointer'}}
                            onClick={() => { navigator.clipboard.writeText("Dabit-getSMS /s-[SenderName] /stDate-[Start Date] /endDate-[End Date]"); showSuccess("Command Format Copied!"); }}
                        >
                            Dabit-getSMS /s-[SenderName] /stDate-[Start Date] /endDate-[End Date]
                        </div>
                        <div className="small text-muted mb-1">bKash এর উদাহরণ:</div>
                        <div 
                            className="bg-light p-2 border rounded mb-1 text-danger font-monospace user-select-all" 
                            style={{cursor: 'pointer'}}
                            onClick={() => { navigator.clipboard.writeText("Dabit-getSMS /s-bKash /stDate-09-03-2026 08:30 am /endDate-09-03-2026 09:30 pm"); showSuccess("bKash Example Copied!"); }}
                        >
                            Dabit-getSMS /s-bKash /stDate-09-03-2026 08:30 am /endDate-09-03-2026 09:30 pm
                        </div>
                        <div className="small text-muted mb-1">Nagad এর উদাহরণ:</div>
                        <div 
                            className="bg-light p-2 border rounded text-warning font-monospace user-select-all" 
                            style={{cursor: 'pointer'}}
                            onClick={() => { navigator.clipboard.writeText("Dabit-getSMS /s-Nagad /stDate-09-03-2026 01:00 pm /endDate-09-03-2026 02:30 pm"); showSuccess("Nagad Example Copied!"); }}
                        >
                            Dabit-getSMS /s-Nagad /stDate-09-03-2026 01:00 pm /endDate-09-03-2026 02:30 pm
                        </div>
                    </div>

                </div>
                <div className="modal-footer py-2 bg-light">
                    <button type="button" className="btn btn-sm btn-secondary" onClick={() => setShowSmsDocModal(false)}>Close Guide</button>
                </div>
            </div>
        </div>
    </div>
)}
        </Layout>
    );
};

export default UserDeviceManager;